import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TasksComponent } from './tasks.component';
import { AuthGuard }      from '../shared/auth.guard';


@NgModule({
  imports: [
    RouterModule.forChild([
      { path: 'tasks', component: TasksComponent,  canActivate: [AuthGuard] }
    ])
  ],
  exports: [RouterModule]
})
export class TasksRoutingModule { 

  
}
